module.exports = __webpack_public_path__ + "static/media/arrow-right-white.a056b214.svg";